import styles from "./FocusCover.module.css";

function FocusCover({ state, setState, background = false }) {
    function handleFocusCoverClick() {
        setState(false);
    }

    return (
        <div
            id={styles.focus_cover}
            className={[
                state ? "" : styles.hide,
                background ? styles.background : "",
            ].join(" ")}
            onClick={handleFocusCoverClick}
        ></div>
    );
}

export default FocusCover;
